import { createContext } from "react";

import { type useQuery } from "@apollo/client";

import {
    type GetUserInfoQuery,
    type GetUserInfoQueryVariables,
    type UserProfileQuery,
    type UserProfileQueryVariables,
} from "../queries";

export const UserInfoContext = createContext<
    | ReturnType<typeof useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>>
    | ReturnType<typeof useQuery<UserProfileQuery, UserProfileQueryVariables>>
    | undefined
>(undefined);
